import { IVirkesorderFilter } from "./IVirkesorderFilter";

export class VirkesorderFilter implements IVirkesorderFilter {
    mottagare: string;
    avtalatMattslag: string[];
    redovisningshanvisning: string;
    skordarmatning?: boolean;

    constructor() {
        this.mottagare = null;
        this.avtalatMattslag = [];
        this.redovisningshanvisning = null;
        this.skordarmatning = undefined;
    }
}
